"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _trayMenu = require("@ux/tray-menu");
var _enums = require("../enums");
var _eid = _interopRequireDefault(require("../eid"));
var _reactMintl = require("@godaddy/react-mintl");
var _link = _interopRequireDefault(require("@ux/link"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
/* jscs:disable requireSpacesInsideJsxExpressionContainers */

/**
 * Render CreateMyAccount section.
 *
 * @Constructor
 * @class CreateMyAccount
 * @api public
 */
class CreateMyAccount extends _react.Component {
  constructor(props) {
    super(...arguments);
    this.eids = {
      createAccount: (0, _eid.default)({
        key: _enums.golf.createAccount,
        manifest: props.manifest
      })
    };
  }
  render() {
    const props = this.props;
    const eids = this.eids;
    return /*#__PURE__*/_react.default.createElement(_reactMintl.IntlProvider, {
      locale: props.market,
      messages: props.messages
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "sign-up"
    }, /*#__PURE__*/_react.default.createElement(_trayMenu.TrayTitle, null, /*#__PURE__*/_react.default.createElement(_reactMintl.FormattedMessage, {
      id: _enums.golf.newCustomerHeading
    })), /*#__PURE__*/_react.default.createElement("p", null, /*#__PURE__*/_react.default.createElement(_reactMintl.FormattedMessage, {
      id: _enums.golf.newCustomerMessage,
      values: {
        privateLabelName: props.privateLabelName
      }
    }), ' ', /*#__PURE__*/_react.default.createElement(_reactMintl.FormattedMessage, {
      id: _enums.golf.createAccountMessage
    })), /*#__PURE__*/_react.default.createElement(_link.default, {
      className: "ux-button ux-button-secondary ux-button-small",
      "data-version": "2400",
      urlArgs: props.urlArgs,
      href: props.createAccountLink,
      "data-eid": eids.createAccount
    }, /*#__PURE__*/_react.default.createElement(_reactMintl.FormattedMessage, {
      id: _enums.golf.createAccount
    }))));
  }
}

/**
 * Require properties.
 *
 * @type {Object}
 * @api public
 */
CreateMyAccount.propTypes = {
  createAccountLink: _propTypes.default.string.isRequired,
  market: _propTypes.default.string.isRequired,
  messages: _propTypes.default.object.isRequired,
  manifest: _propTypes.default.string,
  privateLabelName: _propTypes.default.string,
  urlArgs: _propTypes.default.object
};
var _default = exports.default = CreateMyAccount;